import React from "react";
import PropTypes from "prop-types";
import { withElementWrapper } from "../withElementWrapper";
import "./text.m.css";

const TextBase = ({ element = {}, AdComponent, story, ...restProps }) => {
  const content = element?.text;
  if (!content) return null;
  const newTextElement = content.match(/(<([^>\s]+)(?:\s[^>]*)?>.*?<\/\2>|<[^>\s]+(?:\s[^>]*)?\/>)/g);
  if (!newTextElement) return null;

  return newTextElement.map((item, index) => {
    if (item.includes("ad_goes_here")) {
      const jsonMatch = item.match(/\{.*\}/);
      const adIndexNo = JSON.parse(jsonMatch[0]).index;
      return AdComponent ? <AdComponent key={index} adIndexNo={adIndexNo} /> : null;
    }

    return (
      <div
        className="arrow-component arr--text-element"
        styleName="text-element"
        data-test-id="text"
        id="text-element"
        key={index}
        dangerouslySetInnerHTML={{ __html: item }}
        {...restProps}
      />
    );
  });
};

TextBase.propTypes = {
  element: PropTypes.shape({ text: PropTypes.string }),
  AdComponent: PropTypes.node,
  story: PropTypes.object,
};

export const Text = withElementWrapper(TextBase);
